import { IWork } from "../../icons/IWork";
import { ITime } from "../../icons/ITime";
import NewAvatarImage, { ICharacterFullImage } from "components/NewAvatarImage";
import CycleTimeSpeedmeterWrapper from "components/CycleTimeSpeedmeterWrapper";
import "./style.scss";

interface WorkDetailProps {
  currentProcessDetail: any;
  targetCycleTimeRange: number;
  targetCycleTimeType: number;
  fullCharacterImage: ICharacterFullImage | null;
  itemZIndex: { hat: number; shoe: number; cloth: number };
  width?: number;
  height?: number;
  ringWidth?: number;
  avatarWidth?: number;
  avatarContainerWidth?: number;
  avatarMaxWidth?: number;
  avatarHeight?: number;
  avatarTop?: number;
  avatarRight?: number;
  avatarTransformY?: number;
  adjustLegendPosition?: number;
}

const WorkDetail = ({
  currentProcessDetail,
  targetCycleTimeRange,
  targetCycleTimeType,
  fullCharacterImage,
  itemZIndex,
  width = 980,
  height = 730,
  ringWidth,
  avatarWidth,
  avatarContainerWidth,
  avatarMaxWidth,
  avatarHeight,
  avatarTop,
  avatarRight,
  avatarTransformY,
  adjustLegendPosition = 1,
}: WorkDetailProps) => {
  return (
    <div
      className="work-detail-right-section"
      style={{
        width: `${width}px`,
        height: `${height}px`,
      }}
    >
      <div className="cycleTimeAvater">
        <div className="cycleSpeedmeter">
          <CycleTimeSpeedmeterWrapper
            currentCycleTime={currentProcessDetail?.current_cycle_time || 0}
            standardCycleTime={currentProcessDetail?.standard_cycle_time || 0}
            cycleTimeNormalRange={currentProcessDetail?.cycle_time_normal_range || 0}
            targetCycleTimeRange={targetCycleTimeRange}
            targetCycleTimeType={targetCycleTimeType}
            ringWidth={ringWidth}
            adjustLegendPosition={adjustLegendPosition}
          />
        </div>
        {fullCharacterImage !== null && (
          <NewAvatarImage
            fullImage={fullCharacterImage}
            itemZIndex={itemZIndex}
            style={{
              ...(avatarWidth && { '--avatar-width': `${avatarWidth}px` }),
              ...(avatarContainerWidth && { '--avatar-container-width': `${avatarContainerWidth}px` }),
              ...(avatarMaxWidth && { '--avatar-max-width': `${avatarMaxWidth}px` }),
              ...(avatarHeight && { '--avatar-height': `${avatarHeight}px` }),
              ...(avatarTop && { '--avatar-top': `${avatarTop}%` }),
              ...(avatarRight && { '--avatar-right': `${avatarRight}px` }),
              ...(avatarTransformY && { '--avatar-transform-y': `${avatarTransformY}%` }),
            } as React.CSSProperties}
          />
        )}
      </div>
      <div className="totalDataWrapper">
        <div className="totalDataRows">
          <div className="totalDataParts">
            <div className="total-number-work">
              <div className="totalNumberWork__innerWrapper">
                <div className="legend">
                  <IWork />
                  <p>総作業台数</p>
                </div>
                <p className="data">{currentProcessDetail?.total_product}</p>
              </div>
            </div>
          </div>
          <div className="totalDataParts">
            <div className="total-number-work total-number-work-sub">
              <div className="totalNumberWork__innerWrapper">
                <div className="legend">
                  <IWork />
                  <p>今日の作業台数</p>
                </div>
                <p className="data">
                  {currentProcessDetail?.total_product_in_day}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="totalDataRows">
          <div className="totalDataParts">
            <div className="total-number-time">
              <div className="totalNumberTime__innerWrapper">
                <div className="legend">
                  <ITime />
                  <p>総作業時間</p>
                </div>

                <p className="data">
                  {((currentProcessDetail?.total_cumulative_time || 0) / 3600).toFixed(2)}
                </p>
              </div>
            </div>
          </div>
          <div className="totalDataParts">
            <div className="total-number-time total-number-time-sub">
              <div className="totalNumberTime__innerWrapper">
                <div className="legend">
                  <ITime />
                  <p>今日の作業時間</p>
                </div>
                <p className="data">
                  {((currentProcessDetail?.total_cycle_time_in_day || 0) / 3600).toFixed(2)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkDetail;
